interface Props {
  total: number;
  current: number; // 1-indexed, currently active cycle
  isComplete: boolean;
}

export default function BreathingCycleProgress({ total, current, isComplete }: Props) {
  return (
    <div className="flex items-center justify-center gap-2" role="group" aria-label={`Cycle ${current} of ${total}`}>
      {Array.from({ length: total }, (_, i) => {
        const cycleNum = i + 1;
        const filled = isComplete ? true : cycleNum < current;
        return (
          <span
            key={i}
            aria-hidden="true"
            className="rounded-full transition-all duration-300"
            style={{
              width: 8,
              height: 8,
              backgroundColor: filled ? "#2D5A3D" : "rgba(45, 90, 61, 0.2)",
            }}
          />
        );
      })}
    </div>
  );
}
